const id = {
	search_placeholder: "Cari...",
	select_row: "Pilih baris",
	select_all: "Pilih semua baris",
	loading: "Memuat...",
	status: "Status",
	ref_id: "Ref ID",
	email: "Email",
	qty: "Qty",
	total: "Total",
	detail: "Detail",
	footer: {
		row_out_of: "dari",
	},
};

export default id;
